/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';


export const SvgBlockUser = ({ size,tinColor = "#bd202c" }) => {
    return (<Svg
        height={size}
        width={size}
        viewBox="0 0 535.9 568.79" >

        <G id="Layer_2" data-name="Layer 2">
            <G id="Layer_1-2" data-name="Layer 1">
                <Rect class="cls-1" fill={tinColor} width="535.9" height="568.79" rx="53.62" ry="53.62" />
                <Path class="cls-2" fill="#fff" d="M427.43,379.12a159.37,159.37,0,0,0-90.68-129.21,97,97,0,1,0-137.56,0,159.32,159.32,0,0,0-90.72,129.17l-.46,4.7,3,3.65a202.8,202.8,0,0,0,101.67,66.22,65.29,65.29,0,0,0,110.67-.26,202.13,202.13,0,0,0,101.51-66l3-3.65ZM267.95,107.37a74.24,74.24,0,1,1-74.24,74.24A74.32,74.32,0,0,1,267.95,107.37Zm-42.7,311.36A42.64,42.64,0,0,1,289,381.6l-58.15,58.15A42.39,42.39,0,0,1,225.24,418.72Zm42.7,42.7a42.39,42.39,0,0,1-21-5.58l58.15-58.15a42.64,42.64,0,0,1-37.12,63.73ZM333,425.72a65.48,65.48,0,1,0-130,.76,180.18,180.18,0,0,1-71.33-49.86c6.8-51.91,41.95-93.33,88.83-110.47a96.68,96.68,0,0,0,94.86,0c46.92,17.09,82.09,58.49,88.9,110.43A177,177,0,0,1,333,425.72Z" />
            </G>
        </G>

    </Svg>)
}

